import React, { useState } from 'react';

// Placeholder prices - these can be adjusted or fetched from an API
const BASE_PRICE_PER_THOUSAND = 500; // Base price for pocket folders per thousand units
const STAMPING_ADD_ON = 100; // Additional cost per thousand for stamping
const EMBOSSING_ADD_ON = 150; // Additional cost per thousand for embossing
const DIE_CUTTING_ADD_ON = 200; // Additional cost per thousand for die cutting

const BinderyQuoteComponent = () => {
  const [quantities, setQuantities] = useState([1]); // Array of quantities in thousands
  const [newQuantity, setNewQuantity] = useState(1); // For adding new quantity
  const [stamping, setStamping] = useState(false);
  const [embossing, setEmbossing] = useState(false);
  const [dieCutting, setDieCutting] = useState(false);
  const [quotes, setQuotes] = useState([]);

  const addQuantity = () => {
    if (newQuantity > 0) {
      setQuantities([...quantities, parseFloat(newQuantity)]);
      setNewQuantity(1);
    }
  };

  const removeQuantity = (index) => {
    const updated = quantities.filter((_, i) => i !== index);
    setQuantities(updated);
  };

  const updateQuantity = (index, value) => {
    const updated = [...quantities];
    updated[index] = parseFloat(value) || 0;
    setQuantities(updated);
  };

  const calculateQuotes = () => {
    const calculated = quantities.map((thousands) => {
      let baseCost = thousands * BASE_PRICE_PER_THOUSAND;
      if (stamping) baseCost += thousands * STAMPING_ADD_ON;
      if (embossing) baseCost += thousands * EMBOSSING_ADD_ON;
      if (dieCutting) baseCost += thousands * DIE_CUTTING_ADD_ON;
      return { quantity: thousands, total: baseCost };
    });
    setQuotes(calculated);
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">
        Pocket Folder Bindery Quote Calculator
      </h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Quantities (in thousands)</label>
          {quantities.map((qty, index) => (
            <div key={index} className="flex items-center mt-2">
              <input
                type="number"
                value={qty}
                onChange={(e) => updateQuantity(index, e.target.value)}
                className="block w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              />
              {quantities.length > 1 && (
                <button
                  onClick={() => removeQuantity(index)}
                  className="ml-2 bg-red-600 text-white p-2 rounded-md hover:bg-red-700 transition"
                >
                  Remove
                </button>
              )}
            </div>
          ))}
          <div className="flex items-center mt-2">
            <input
              type="number"
              value={newQuantity}
              onChange={(e) => setNewQuantity(e.target.value)}
              className="block w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
              placeholder="Add new quantity"
            />
            <button
              onClick={addQuantity}
              className="ml-2 bg-green-600 text-white p-2 rounded-md hover:bg-green-700 transition"
            >
              Add
            </button>
          </div>
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            id="stamping"
            checked={stamping}
            onChange={(e) => setStamping(e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="stamping" className="ml-2 text-sm text-gray-700">
            Add Stamping (+$100 per thousand)
          </label>
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            id="embossing"
            checked={embossing}
            onChange={(e) => setEmbossing(e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="embossing" className="ml-2 text-sm text-gray-700">
            Add Embossing (+$150 per thousand)
          </label>
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            id="dieCutting"
            checked={dieCutting}
            onChange={(e) => setDieCutting(e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="dieCutting" className="ml-2 text-sm text-gray-700">
            Add Die Cutting (+$200 per thousand)
          </label>
        </div>
        <button
          onClick={calculateQuotes}
          className="w-full bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 transition"
        >
          Calculate Quotes
        </button>
        {quotes.length > 0 && (
          <div className="mt-4">
            <h3 className="text-lg font-semibold text-gray-800">Quotes:</h3>
            <table className="min-w-full bg-white border border-gray-300 mt-2">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b">Quantity (thousands)</th>
                  <th className="py-2 px-4 border-b">Total Quote</th>
                </tr>
              </thead>
              <tbody>
                {quotes.map((quote, index) => (
                  <tr key={index}>
                    <td className="py-2 px-4 border-b text-center">{quote.quantity}</td>
                    <td className="py-2 px-4 border-b text-center">${quote.total.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default BinderyQuoteComponent;